export default {
      id: "arrow-left-usage",
      viewBox: "0 0 8 12",
      url: __webpack_public_path__ + "sprite.1790760972825.svg#arrow-left-usage",
      toString: function () {
        return this.url;
      }
    }